import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { bulkdeductionSchemaObject } from "../bulkdeductionSchema";
import { validateProperty, validate } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import { PageHeader } from "../../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import collectionCatagoryService from "../../CollectionCategory/services";
import { MultiSelect } from "../../../Common/multiSelect";

const screenCode = "BULKDEDUCTIONTEMPLATE";

export function BulkDeductionAddEdit(props) {

  const [selectedOptions, setSelectedOptions] = useState([]);
  const getOptionLabel = option => `${option.label}`;
  const getOptionDisabled = option => option.value === "foo";
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(alldeductionType);
    } else {
      handleClearOptions();
    }
  };
  const [pageProperties, setPageProperties] = useState({
    title: "Add Bulk Deduction Template",
    buttonText: "Save",
  });
  const [groups, setGroups] = useState();
  const [factoriesData, setFactoriesData] = useState();
  const [collectionCatagory, setCollectionCatagory] = useState();
  const [isDropdownDisable, setIsDropdownDisable] = useState(false);
  const [alldeductionType, setAllDeductionType] = useState([]);
  const [deductionType, setDeductionType] = useState();
  const [applyMethods, setApplyMethods] = useState();
  const [deduction, setDeduction] = useState({
    deductionTemplateID: "0",
    groupID: 0,
    groupName: "",
    operationEntityID: 0,
    factoryName: "",
    collectionPointID: 0,
    collectionCategoryMenuID: 0,
    collectionPointName: "",
    deductionTypeID: 0,
    deductionTypeName: "",
    applyMethodID: "0",
    collectionCategoryID: 0,
    defaultValue: 0,
    minimumValue: 0,
    isFixed: false,
    isActive: true,
    isDefaultValueEnabled: false,
    createdBy: 0,
    createdDate: "",
    entityTypeID: 0,
    fixedDeductions: [],
  });
  const [errors, setErrors] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success",
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const [collectionCategoryMenus, setCollectionCategoryMenus] = useState();
  const [deletedValues, setDeletedValues] = useState({
    deleted: [],
  });
  const schema = Joi.object(bulkdeductionSchemaObject).options({
    allowUnknown: true,
  });
  const [state, setState] = useState({
    columns: [
      { title: "Deduction Type", field: "name" },
      { title: "Value", field: "value", type: "numeric" },
    ],
    data: [],
  });
  const [deductionData, setDeductionData] = useState([]);


  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (deduction.groupID != 0) {
      trackPromise(getOperationEntitiesForDropdown());
    }
  }, [deduction.groupID]);

  useEffect(() => {
    if (deduction.operationEntityID != 0) {
      trackPromise(getCollectionCatagoryForDropDown());
    }
  }, [deduction.operationEntityID]);

  useEffect(() => {
    if (deduction.collectionCategoryID != 0) {
      trackPromise(setCollectionCategoryMenusDropDownData());
    }
  }, [deduction.collectionCategoryID]);

  useEffect(() => {
    if (deduction.deductionTypeID != 0) {
    trackPromise(getallAvailableCollectionPointByDeductionType());
    }
  }, [deduction.deductionTypeID]);
  



  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "ADDEDITBULKDEDUCTIONTEMPLATE"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();
    setDeduction({
      ...deduction,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });
    trackPromise(
      setGroupDropDownData(),
      setApplyMethodsData(),
      setDeductionTypeDropDownData()
    );
  }

  async function setGroupDropDownData() {
    const result = await services.getGroups();
    setGroups(result);
  }

  async function getOperationEntitiesForDropdown() {
    const opEntities = await services.getAllOperationEntitiesForDropDown(deduction.groupID);
    setFactoriesData(opEntities);
  }

  async function getCollectionCatagoryForDropDown() {
    const collectionCatagory = await collectionCatagoryService.GetCollectionCategoryByOperationEntityID(deduction.operationEntityID);
    setCollectionCatagory(collectionCatagory);
  }

  async function setCollectionCategoryMenusDropDownData() {
    const result = await services.getAllCollectionCategoryMenusForDropdown(deduction.collectionCategoryID);
    setCollectionCategoryMenus(result);
  }

  async function setDeductionTypeDropDownData() {
    const result = await services.getDeductionTypes();
    setDeductionType(result);
  }

  async function getallAvailableCollectionPointByDeductionType() {
    let filteredData = await services.getAvailableCollectionPointByDeductionType(
      deduction.groupID,
      deduction.operationEntityID,
      deduction.collectionCategoryMenuID,
      deduction.deductionTypeID
    );
    
    var options = []
    for (let item of Object.entries(filteredData)) {
          options.push({ label: item[1]["collectionPointName"], value: item[1]["collectionPointID"] });
    }
    setAllDeductionType(options);
  }

  async function setApplyMethodsData() {
    const result = await services.getApplyMethods();
    setApplyMethods(result);
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, bulkdeductionSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];
    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
      groupID: target.value,
      operationEntityID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
      operationEntityID: target.value,
      collectionCategoryID: "0",
    });
  }

  function handleCollectionCategoryChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
      collectionCategoryID: target.value,
      collectionCategoryMenuID: "0",
    });
  }
  function handleDeductionTypeChange(e) {
    const target = e.target;

    const value = target.type === "checkbox" ? target.checked : target.value;
    setDeduction({
      ...deduction,
      [e.target.name]: value,
    });
  }

  function handleChange(e) {
    const target = e.target;

    const value = target.type === "checkbox" ? target.checked : target.value;
    setDeduction({
      ...deduction,
      [e.target.name]: value,
    });
  }

  async function handleSpecialDeductionChange(e){
    const target = e.target
    const value = target.type === 'checkbox' ? target.checked : target.value
  
    if(target.name === "isDefaultValueEnabled"){
  
        if(value){
            setDeduction({
                ...deduction,
                [e.target.name]: value,
                "isFixed" : false,
                "isDefaultValueEnabled": true
            })  
        }
        else{
            setDeduction({
                ...deduction,
                [e.target.name]: value,
                "isDefaultValueEnabled": false
            })
        }  
    }
  
    else{
  
        if(value){
            setDeduction({
                ...deduction,
                [e.target.name]: value,
                  "isFixed" : true,
                  "isDefaultValueEnabled": false
                }) 
        }
        else{
            setDeduction({
                ...deduction,
                [e.target.name]: value,
                  "isFixed" : false,
                })
        }
    }
  }

  async function handleSave(e) {
    e.preventDefault();
    
    const target = e.target;

    const errorMessages = validate(schema, deduction);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) {
      return;
    }

    var result = [...selectedOptions];
    if(result.length > 0){
      let deductionDataBindCopy = deductionDataBindToCollectionPoint();
      saveData(deductionDataBindCopy);
    }
    setErrors(errors);
  }

  async function saveData(data) {
    if (!data.isDefaultValueEnabled) {
      data.defaultValue = 0;
    }

    const response = await services.saveData(data);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      afterSuccessfulyChanged(response.statusCode);
  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      clearState();
      setTimeout(() => {
        modalDismissHandler();
        refreshPage();
      }, 1500);
    }
    if (response === "Warning") {
      clearState();
      refreshPage();
    }
  }

  function refreshPage(){
    window.location.reload(false); 
   }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function clearState() {
    var token = tokenService.getUserDetailsFromToken();
    setDeduction({
      ...deduction,
      deductionTemplateID: "0",
      groupID: permissionList.isGroupFilterEnabled ? "0" : token.groupID,
      groupName: "",
      operationEntityID: permissionList.isOperationEntityFilterEnabled
        ? "0"
        : token.operationEntityID,
      factoryName: "",
      collectionPointID: 0,
      collectionCategoryMenuID: 0,
      collectionPointName: "",
      deductionTypeID: "0",
      deductionTypeName: "",
      applyMethodID: "0",
      collectionCategoryID: "0",
      defaultValue: "",
      minimumValue: "",
      isActive: true,
      isDefaultValueEnabled: false,
      createdBy: "",
      createdDate: "",
      entityTypeID: 0,
    });
    handleClearOptions();
    setState([]);
  }

  function renderDropDown(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function onClickCancel() {
    clearState();
  }

   function deductionDataBindToCollectionPoint() {

     var id = tokenService.getUserIDFromToken();
     let deductionDataCopy = [...deductionData];

     var fixedDeductionsArray = [];
     state.data.map((item) => {
       let data = {
         fixedDeductionID: 0,
         name: item.name,
         value: parseFloat(item.value),
         isActive: true,
         createdBy: parseInt(id),
       };
       fixedDeductionsArray.push(data);
     });

     selectedOptions.forEach((x) => {
       let deductionDataValue = {
         deductionTemplateID: 0,
         groupID: parseInt(deduction.groupID),
         operationEntityID: parseInt(deduction.operationEntityID),
         collectionPointID: parseInt(x.value),
         collectionCategoryMenuID: parseInt(deduction.collectionCategoryMenuID),
         deductionTypeID: parseInt(deduction.deductionTypeID),
         applyMethodID: parseInt(deduction.applyMethodID),
         defaultValue: parseFloat(deduction.defaultValue),
         minimumValue: parseFloat(deduction.minimumValue),
         createdBy: parseInt(id),
         createdDate: new Date().toISOString(),
         modifiedBy: 0,
         modifiedDate: new Date().toISOString(),
         isFixed: deduction.isFixed,
         isActive: deduction.isActive,
         isDefaultValueEnabled: deduction.isDefaultValueEnabled,
         fixedDeductions: fixedDeductionsArray,
       };

       deductionDataCopy.push(deductionDataValue);
     });

     return deductionDataCopy;
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <PageHeader title={pageProperties.title} />
            </div>

            <div className="form-group row">
              <div className="col-md pb-1">
                <InputLabel shrink id="groupID">
                  Group *
                </InputLabel>
                <Select
                  fullWidth
                  id="groupID"
                  disabled={
                    isDropdownDisable || !permissionList.isGroupFilterEnabled
                  }
                  name="groupID"
                  value={deduction.groupID}
                  onChange={(e) => handleGroupChange(e.target)}
                >
                  <MenuItem value="0">--Select Group Name--</MenuItem>
                  {renderDropDown(groups)}
                </Select>
                {errors["groupID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>)}
              </div>

              <div className="col-md pb-1">
                <InputLabel shrink id="operationEntityID">
                  Operation Entity *
                </InputLabel>
                <Select
                  fullWidth
                  id="operationEntityID"
                  disabled={
                    isDropdownDisable ||
                    !permissionList.isOperationEntityFilterEnabled
                  }
                  name="operationEntityID"
                  value={deduction.operationEntityID}
                  onChange={(e) => handleOperationEntityChange(e.target)}
                >
                  <MenuItem value="0">--Select Operation Entity--</MenuItem>
                  {renderDropDown(factoriesData)}
                </Select>
                {errors["operationEntityID"] && (
                  <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>)}
              </div>

              <div className="col-md pb-1">
                <InputLabel shrink id="collectionCategoryID">
                  Collection Category *
                </InputLabel>
                <Select
                  fullWidth
                  id="collectionCategoryID"
                  name="collectionCategoryID"
                  value={deduction.collectionCategoryID}
                  onChange={(e) => handleCollectionCategoryChange(e.target)}
                >
                  <MenuItem value="0">--Select Collection Catagory--</MenuItem>
                  {renderDropDown(collectionCatagory)}
                </Select>
                {errors["collectionCategoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</FormHelperText>)}
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md pb-1">
                <InputLabel shrink id="collectionCategoryMenuID">
                  Collection Category Menu *
                </InputLabel>
                <Select
                  fullWidth
                  id="collectionCategoryMenuID"
                  name="collectionCategoryMenuID"
                  value={deduction.collectionCategoryMenuID}
                  onChange={(e) => handleChange(e)}
                >
                  <MenuItem value="0">--Collection Category Menu--</MenuItem>
                  {renderDropDown(collectionCategoryMenus)}
                </Select>
                {errors["collectionCategoryMenuID"] && (
                  <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryMenuID"]}</FormHelperText>)}
              </div>

              <div className="col-md pb-1">
                <InputLabel shrink id="deductionTypeID">
                  Deduction Type *
                </InputLabel>
                <Select
                  fullWidth
                  id="deductionTypeID"
                  name="deductionTypeID"
                  value={deduction.deductionTypeID}
                  onChange={(e) => handleDeductionTypeChange(e)}
                  checked={deduction.deductionTypeID}
                >
                  <MenuItem value="0">--Select Deduction Type--</MenuItem>
                  {renderDropDown(deductionType)}
                </Select>
                {errors["deductionTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["deductionTypeID"]}</FormHelperText>)}
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md pb-1">
              <MultiSelect
                  items={alldeductionType}
                  getOptionLabel={getOptionLabel}
                  getOptionDisabled={getOptionDisabled}
                  selectedValues={selectedOptions}
                  label="Select Available Collection Points"
                  placeholder="Collection Points"
                  selectAllLabel="Select all"
                  onToggleOption={handleToggleOption}
                  onClearOptions={handleClearOptions}
                  onSelectAll={handleSelectAll}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={(e) =>handleSave(e)}>
              <div className="form-group row">
                <div className="col-md-4 pb-1">
                  <InputLabel shrink id="applyMethodID">
                    Apply method
                  </InputLabel>
                  <Select
                    fullWidth
                    id="applyMethodID"
                    name="applyMethodID"
                    value={deduction.applyMethodID}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value="0">--Select Apply Method--</MenuItem>
                    {renderDropDown(applyMethods)}
                  </Select>
                  {errors["applyMethodID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["applyMethodID"]}</FormHelperText>)}
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md pb-1">
                  <InputLabel shrink id="def">
                    Active
                  </InputLabel>
                  <input
                    className="mr-2"
                    id="isActive"
                    type="checkbox"
                    switch="none"
                    name="isActive"
                    onChange={(e) => handleChange(e)}
                    checked={deduction.isActive}
                  />
                  <label
                    htmlFor="isActive"
                    data-on-label="Yes"
                    data-off-label="No"
                  ></label>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-2">
                  <InputLabel shrink id="def">
                      Default Deduction Enabled
                    </InputLabel>
                    <input
                      className="mr-2"
                      id="defaultValueEnabled"
                      switch="none"
                      type="checkbox"
                      name="isDefaultValueEnabled"
                    onChange={(e) => handleSpecialDeductionChange(e)}
                      checked={deduction.isDefaultValueEnabled}
                    />
                    <label
                      htmlFor="defaultValueEnabled"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                </div>
                <div className="col-md-2">
                  <InputLabel shrink id="def">
                    Is Fixed Deduction
                  </InputLabel>
                  <input
                    className="mr-2"
                    id="fixed"
                    switch="none"
                    type="checkbox"
                    name="isFixed"
                    onChange={(e) => handleSpecialDeductionChange(e)}
                    checked={deduction.isFixed}
                  />
                  <label
                    htmlFor="fixed"
                    data-on-label="Yes"
                    data-off-label="No"
                  ></label>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md pb-2">
                  {deduction.isDefaultValueEnabled ? (
                    <div className="form-group row">
                      <div className="col-md-6">
                        <InputLabel shrink id="defaultValue">
                          Default Value
                        </InputLabel>
                        <TextField
                          fullWidth
                          type="text"
                          className="form-control"
                          value=""
                          name="defaultValue"
                          id="defaultValue"
                          onChange={(e) => handleChange(e)}
                          value={deduction.defaultValue}
                        />
                        {errors["defaultValue"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["defaultValue"]}</FormHelperText>)}
                      </div>
                      <div className="col-md-6">
                        <InputLabel shrink id="minimumValue">
                          Minimum Value
                        </InputLabel>
                        <TextField
                          fullWidth
                          type="text"
                          className="form-control"
                          value=""
                          name="minimumValue"
                          id="minimumValue"
                          onChange={(e) => handleChange(e)}
                          value={deduction.minimumValue}
                        />
                        {errors["minimumValue"] && (
                          <FormHelperText id="errbranchCode" className="text text-danger">{errors["minimumValue"]}</FormHelperText>)}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="form-group row">
                {deduction.isFixed ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <MaterialTable
                        hidden={!deduction.isFixed}
                        title="Deduction Types"
                        fullWidth
                        columns={state.columns}
                        data={state.data}
                        options={{ showTitle: false, search: false }}
                        editable={{
                          onRowAdd: (newData) =>
                            new Promise((resolve) => {
                              setTimeout(() => {
                                resolve();
                                setState((prevState) => {
                                  const data = [...prevState.data];
                                  data.push(newData);
                                  return { ...prevState, data };
                                });
                              }, 600);
                            }),
                          onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                              setTimeout(() => {
                                resolve();
                                if (oldData) {
                                  setState((prevState) => {
                                    const data = [...prevState.data];
                                    data[data.indexOf(oldData)] = newData;
                                    return { ...prevState, data };
                                  });
                                }
                              }, 600);
                            }),
                          onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                              setTimeout(() => {
                                resolve();

                                setState((prevState) => {
                                  const data = [...prevState.data];
                                  data.splice(data.indexOf(oldData), 1);
                                  return { ...prevState, data };
                                });
                                setDeletedValues((prevState) => {
                                  const deleted = [...prevState.deleted];
                                  deleted.push(oldData);
                                  return { ...prevState, deleted };
                                });
                              }, 600);
                            }),
                        }}
                      />
                    </Grid>
                  </Grid>
                ) : null}
              </div>

              <div className="card-footer">
                <input
                  disabled={validate(schema, deduction)}
                  type="submit"
                  className="btn btn-primary"
                  value={pageProperties.buttonText}
                />
                <input
                  type="button"
                  className="btn btn-warning pull-right"
                  value="Clear"
                  onClick={onClickCancel}
                />
              </div>
            </form>
          </div>
        </div>
        <MessageModal
          hidden={messageModel.hidden}
          messageType={messageModel.type}
          messageDescription={messageModel.disciption}
          clicked={modalDismissHandler}
        />
      </div>
    </Fragment>
  );
}
